import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * @file Created on Fri Oct 19 2018
 * @author PKr
 */


import { Theme, ThemesViewDTO } from '@logio/common-be-fe';
import { action, observable, runInAction } from 'mobx';
import { ThemeLayer } from '../../transportLayers/theme/ThemeLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { Map } from 'immutable';
/** Persistent store for Themes */

export var ThemeStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(ThemeStore, _BaseStore);

  function ThemeStore() {
    var _this;

    _classCallCheck(this, ThemeStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ThemeStore).apply(this, arguments));
    /** Store name */

    _this.name = StoreName.Theme;
    /** Layer contains methods for fetching data */

    _this.themeLayer = new ThemeLayer();
    /** List of Themes */

    _this.list = Map();
    /**
     * Fletches all Themes (ThemesViewDTOs)
     * returns a promise with Map of items
     */

    _this.getAll = function () {
      return _this.themeLayer.getAllViews().then(function (themeViews) {
        runInAction(function () {
          _this.list = _this.list.clear();
          themeViews.forEach(function (themeView) {
            _this.list = _this.list.set(themeView.theme.id, themeView);
          });
        });
        return _this.list;
      });
    };
    /**
     * Fetches one theme
     * @param itemId
     * @returns a promise with theme
     */


    _this.getOne = function (itemId) {
      return _this.themeLayer.findOne(itemId).then(function (theme) {
        return theme;
      });
    };
    /**
     * Fetches themes by filter params (ThemesViewDTOs)
     * @param filter
     * @returns a promise with Themes
     */


    _this.filter = function (filter) {
      return _this.themeLayer.filter(filter).then(function (themeViews) {
        runInAction(function () {
          themeViews.forEach(function (themeView) {
            _this.list = _this.list.set(themeView.theme.id, themeView);
          });
        });
        return themeViews;
      });
    };
    /**
     * Creates new theme using ThemeLayer
     * Updates theme list on success
     * @param theme - new theme that you want to create
     */


    _this.create = function (theme) {
      return _this.themeLayer.create(theme).then(function (updatedTheme) {
        var newView = new ThemesViewDTO(updatedTheme, 0);
        runInAction(function () {
          _this.list = _this.list.set(updatedTheme.id, newView);
        });
      });
    };
    /**
     * Updates theme using ThemeLayer
     * Updates theme list on success
     * @param theme - theme that you want to update
     */


    _this.update = function (theme) {
      return _this.themeLayer.update(theme).then(function (updatedTheme) {
        var newView = new ThemesViewDTO(updatedTheme, 0);
        runInAction(function () {
          _this.list = _this.list.set(updatedTheme.id, newView);
        });
      });
    };
    /**
     * Deletes theme using ThemeLayer
     * Updates theme list on success
     * @param id - id of the theme that you want to delete.
     */


    _this.delete = function (id) {
      return _this.themeLayer.delete(id).then(function () {
        runInAction(function () {
          _this.list = _this.list.delete(id);
        });
        return _this.list;
      });
    };

    return _this;
  }
  /**
   * Fetches Theme detail
   * @param itemId
   * @returns a promise with theme
   */


  _createClass(ThemeStore, [{
    key: "getThemeDetail",
    value: function getThemeDetail(itemId) {
      var _this2 = this;

      return this.themeLayer.findOne(itemId).then(function (theme) {
        runInAction(function () {
          _this2.detail = theme;
        });
        return theme;
      });
    }
  }]);

  return ThemeStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Theme)], ThemeStore.prototype, "detail", void 0);

__decorate([observable, __metadata("design:type", Object)], ThemeStore.prototype, "list", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], ThemeStore.prototype, "getThemeDetail", null);